import { SignedIn, SignedOut, useClerk } from "@clerk/clerk-react";
import { t, Trans } from "@lingui/macro";
import { Button } from "@reactive-resume/ui";
import { AlertTriangle, LogOut } from "lucide-react";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate } from "react-router-dom";

export const AccountLinkConflictPage = () => {
  const { signOut } = useClerk();
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async () => {
    setSigningOut(true);
    try {
      await signOut({ redirectUrl: "/auth/login" });
    } finally {
      setSigningOut(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {t`Account needs attention`} - {t`theResume`}
        </title>
      </Helmet>

      <SignedOut>
        <Navigate to="/auth/login" replace />
      </SignedOut>

      <SignedIn>
        <div role="alert" className="rounded-2xl border border-amber-200 bg-white p-6 shadow-sm">
          <div className="flex size-11 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <AlertTriangle className="size-5" aria-hidden="true" />
          </div>

          <h2 className="mt-5 text-2xl font-semibold tracking-tight text-slate-950">
            <Trans>Your account needs a quick identity check.</Trans>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            <Trans>
              Google sign-in succeeded, but this workspace is still linked to an older sign-in
              identity. Your resumes and account data are safe. Please contact support so we can
              restore the link.
            </Trans>
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            <Trans>You do not need to create a new account.</Trans>
          </p>

          <Button
            type="button"
            variant="outline"
            className="mt-6 w-full"
            disabled={signingOut}
            onClick={handleSignOut}
          >
            <LogOut className="mr-2 size-4" aria-hidden="true" />
            {signingOut ? <Trans>Signing out...</Trans> : <Trans>Sign out</Trans>}
          </Button>
        </div>
      </SignedIn>
    </>
  );
};
